const ssoLogin = {
  csc: 'csc'
};

module.exports = Object.assign(
  {},
  ssoLogin
);
